// extracted by css-extract-rspack-plugin
export default {"footer":"footer__wVBq5","footer__element":"footer__element__p5oCJ","footer__element_link":"footer__element_link__VSKuG","footer__element_text":"footer__element_text__JYt4P"};